// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__rhE2t","loaderOuter":"PageOverlayLoader_loaderOuter__3-6yp"};